import { OuSelector } from './confInvOuSelector';

require('./confInvOuSelector.scss');

export const myConfirmInvitationOuSelector = {
  template: require('./confInvOuSelector.html'),
  controllerAs: 'ctrl',
  controller: OuSelector,
};
